import React from "react";
import "./Legend.css";

interface LegendItem {
  color: string;
  label: string;
}

interface LegendProps {
  title: string;
  items: LegendItem[];
}

const Legend: React.FC<LegendProps> = ({ title, items }) => {
  return (
    <div className="legend-container">
      <div className="legend-title">{title}</div>
      <div className="legend-items">
        {items.map((item, index) => (
          <div key={index} className="legend-item">
            <div 
              className="legend-color-square"
              style={{ backgroundColor: item.color }}
            ></div>
            <span className="legend-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Legend;